import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MyAccountService} from "@services/my-account.service";
import {Subscription} from "rxjs";
import {Router} from "@angular/router";
import {OrderService} from "@services/order.service";
import {UrlService} from "@services/url.service";
import {Customer} from "@models/customer";
import {AuthService} from "@services/auth.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {

  elementShow = true;
  order: any;
  shop: any;
  networkClass;

  blockStatus: Subscription;
  settings: any;
  customer: Customer;

  constructor(
    private router: Router,
    private myAccountService: MyAccountService,
    private orderService: OrderService,
    private urlService: UrlService,
    private authService: AuthService,
  ) {

    this.blockStatus = this.myAccountService.getHeaderStatus().subscribe(status => {
      this.elementShow = status;
    });
  }

  ngOnInit(): void {
    this.orderService.orderBS.subscribe((order) => {
      this.order = order;
    });
    this.authService.currentUser.subscribe((customer) => {
      this.customer = customer;
    });
    this.orderService.settingsBS.subscribe(settings => {
      this.settings = settings;
    })
    this.shop = this.urlService.getShop();
    this.networkClass = this.urlService.getNetwork();
  }


}
